import { ShoppingBagIcon } from 'lucide-react';

export const OrderIcon = ShoppingBagIcon;
